import { AllyTools} from "./ally-tools.class";
import { AllyRoot } from "./ally-root.class";
import { AllyObject } from "./ally-object.class";
import { IAllyStats, PluginInjectorApplicationPlugin, PluginInjectorService, PLUGIN_VERSIONS } from "core-client/api";

/**
 * This class serves as the entry point for the plugin.
 * 
 * From outside the plugin interactions occur through this class.
 * 
 * It is responsible for creating the AllyRoot object.
 * 
 * This class is provided to the outside via the class AllyService.
 * 
 * @see AllyService
 */
export class AllyServiceClass {
  /**
   * The AllyTools object of this AllyServiceClass object.
   */
  public tools: AllyTools;
  /**
   * The curently active AllyRoot instance.
   */
  private allyRoot: AllyRoot|null;
  private plugin: PluginInjectorApplicationPlugin.IApplicationPlugin = <PluginInjectorApplicationPlugin.IApplicationPlugin>{};
  constructor(private pluginInjectorService: PluginInjectorService) {
    this.tools = new AllyTools();
    this.allyRoot = null;
  }

  /**
   * Calling this function initialises the Ally plugin.
   *
   * Note: If this function is called while the Ally plugin is already initialised the call to this function will be ignored.
   */
  public init() {
    if (this.allyRoot === null) {
      this.allyRoot = new AllyRoot();
      // Production builds have no Angular debug globals to reach the service from the console.
      (window as Window & {adxAllyStats?: () => IAllyStats}).adxAllyStats = () => this.stats();
    }
  }

  public stats(): IAllyStats {
    const walker = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_ALL);
    let nodes = 1;
    while (walker.nextNode()) {
      nodes++;
    }
    return {nodes, ...AllyObject.stats(), listeners: AllyTools.listenerCount()};
  }

  /**
   * Registers the Ally plugin with the plugin administration.
   *
   * Called by the plugin initializer at application start. The plugin is a
   * mandatory core plugin: it is enabled by default and cannot be disabled by
   * administrators (the toggle is locked in the plugin-edit dialog).
   */
  public register() {
    this.plugin.name = "ALLY";
    this.plugin.enabled = true;
    this.plugin.corePlugin = true;
    this.plugin.description = "Accessibility plugin that improves keyboard accessibility and focus handling - always active and cannot be disabled";
    this.plugin.version = PLUGIN_VERSIONS['ally'];

    this.pluginInjectorService.register(this.plugin);
  };
}
